import type { TimeSlot } from "@abejon/shared";

function formatTime(time: string): string {
  const [h, m] = time.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hour = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${hour}:${m.toString().padStart(2, "0")} ${period}`;
}

interface TimeSlotGridProps {
  slots: TimeSlot[];
  selectedSlot: TimeSlot | null;
  onSelect: (slot: TimeSlot) => void;
  loading?: boolean;
}

export function TimeSlotGrid({ slots, selectedSlot, onSelect, loading }: TimeSlotGridProps) {
  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-gray-200 border-t-gray-900" />
      </div>
    );
  }

  if (slots.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-gray-400">
        No available slots for this date.
      </p>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-2 sm:grid-cols-4" role="group" aria-label="Available time slots">
      {slots.map((slot) => {
        const isSelected = selectedSlot?.startTime === slot.startTime;
        return (
          <button
            key={slot.startTime}
            onClick={() => onSelect(slot)}
            aria-pressed={isSelected}
            aria-label={`Select ${formatTime(slot.startTime)}`}
            className={`rounded-lg border px-3 py-2 text-sm font-medium transition-colors focus-visible:ring-2 focus-visible:ring-gray-900 focus-visible:ring-offset-2 ${
              isSelected
                ? "border-gray-900 bg-gray-900 text-white"
                : "border-gray-200 text-gray-700 hover:border-gray-400"
            }`}
          >
            {formatTime(slot.startTime)}
          </button>
        );
      })}
    </div>
  );
}
